import React from "react";
import styled from "styled-components";

const TooltipWrapper = styled.span`
  position: relative;
  display: inline-block;

  &:hover .tooltip-bubble {
    opacity: 1;
    visibility: visible;
  }
`;

const TooltipTrigger = styled.span`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  cursor: pointer;
`;

const TooltipBubble = styled.span`
  position: absolute;
  ${({ $bottom }) => ($bottom ? "top: 100%;" : "bottom: 100%;")}
  left: 50%;
  transform: translateX(-50%);

  ${({ $bottom }) =>
    $bottom ? "margin-top: 6px;" : "margin-bottom: 6px;"}

  padding: 6px 10px;
  background: #333;
  color: white;
  border-radius: 4px;
  font-size: 15px;
  line-height: 1.4;

  width: max-content;
  max-width: min(280px, calc(100vw - 32px));
  white-space: normal;
  overflow-wrap: break-word;
  box-sizing: border-box;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease;

  z-index: 10;
`;

const Tooltip = ({ children, description, bottom = false }) => {
  return (
    <TooltipWrapper>
      <TooltipTrigger>{children}</TooltipTrigger>
      {description && description.length > 0 && (
        <TooltipBubble
          className="tooltip-bubble"
          $bottom={bottom}
        >
          {description}
        </TooltipBubble>
      )}
    </TooltipWrapper>
  );
};

export default Tooltip;